module.exports = __webpack_public_path__ + "static/img/jklc.7c08e13.png";


//////////////////
// WEBPACK FOOTER
// ./static/jklc.png
// module id = ZPDV
// module chunks = 1